
import React from "react";
import PhotoPicker from "../PhotoPicker";

import {
    Overlay,
    Modal,
    Title,
    Comment,
    Info,
    Field,
    ModalButtons,
    Button
} from "../design";

function formatDate(date) {
    if (!date) return "";

    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(
        String(date)
    );

    return match
        ? `${match[3]}.${match[2]}.${match[1]}`
        : String(date);
}

const CompleteTaskModal = ({
                               task,
                               photos,
                               comment,
                               setComment,
                               saving,
                               photoProcessing,
                               onClose,
                               onComplete,
                               onPhotos,
                               onOpenCamera,
                               onRemovePhoto,
                               onPreview
                           }) => {
    const busy = saving || photoProcessing;

    return (
        <Overlay
            onClick={() => {
                if (!busy) onClose();
            }}
        >
            <Modal
                role="dialog"
                aria-modal="true"
                aria-label="Aufgabe erledigen"
                onClick={e => e.stopPropagation()}
            >
                <Title>Aufgabe erledigen</Title>

                <Comment style={{ marginTop: 15 }}>
                    {task.comment}
                </Comment>

                <Info>
                    {task.house} · {formatDate(task.date)}
                </Info>

                <PhotoPicker
                    label="Fotos nach der Arbeit"
                    photos={photos}
                    disabled={saving}
                    processing={photoProcessing}
                    onFiles={files =>
                        onPhotos(files, "completion")
                    }
                    onCamera={() =>
                        onOpenCamera("completion")
                    }
                    onRemove={index =>
                        onRemovePhoto("completion", index)
                    }
                    onPreview={onPreview}
                />

                <Field>
                    <label htmlFor="todo-completion-comment">
                        Kommentar zur Erledigung
                    </label>

                    <textarea
                        id="todo-completion-comment"
                        value={comment}
                        onChange={e =>
                            setComment(e.target.value)
                        }
                        placeholder="Was wurde erledigt?"
                        maxLength={5000}
                    />
                </Field>

                <ModalButtons>
                    <Button
                        type="button"
                        $secondary
                        disabled={busy}
                        onClick={onClose}
                    >
                        Abbrechen
                    </Button>

                    <Button
                        type="button"
                        disabled={busy || !photos.length}
                        onClick={onComplete}
                    >
                        ✓ Als erledigt speichern
                    </Button>
                </ModalButtons>
            </Modal>
        </Overlay>
    );
};

export default CompleteTaskModal;
